import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Dropzone from 'react-dropzone';
import Clickable from '../../../components/clickable/Clickable';
import styles from '../fields.module.scss';
import { allValidFileExtensions, checkMultiFilesValidation } from '../../../utils/helpers';

class Attachment extends Component {
  constructor(props) {
    super(props);
    const { isRequired, answer, updateFieldErrors } = this.props;

    if (isRequired && (!answer || answer?.length === 0)) {
      updateFieldErrors(['pulpoforms.errors.not_blank']);
    }
  }

  // eslint-disable-next-line react/sort-comp
  handleAnswerChanged(value, fieldId) {
    const {
      handleValueChange, handleFieldErrorChanged, isRequired, updateFieldErrors
    } = this.props;
    handleValueChange(value, fieldId);
    let updatedErrors = [];

    if (!value || value?.length === 0) {
      handleFieldErrorChanged(fieldId, isRequired);
      if (isRequired) {
        updatedErrors = [
          ...updatedErrors,
          'pulpoforms.errors.not_blank'
        ];
      }
    } else {
      handleFieldErrorChanged(fieldId, false);
    }
    updateFieldErrors(updatedErrors);
  }

  handleRemoveImage = (r) => {
    const { answer, fieldId } = this.props;
    const res = answer.filter(e => e !== r);
    this.handleAnswerChanged(res, fieldId);
  };

  handleDrop = (dropped) => {
    if (!checkMultiFilesValidation(dropped, allValidFileExtensions)) return;
    const { answer, fieldId } = this.props;
    const list = answer || [];
    this.handleAnswerChanged([...list, ...dropped], fieldId);
  };

  render() {
    const { fieldId, answer, disabled, formsWorkFlow } = this.props;
    let cls = `${styles.fullInput} `;
    if (formsWorkFlow) cls += `${styles.workflowWidth} `;
    return (
      <div className={cls} id={fieldId}>
        {!disabled && (
          <Dropzone onDrop={this.handleDrop} disableClick
            className={styles.dropzone}
          >
            {({ open }) => (
              <>
                <p className={styles.browsetext}>
                  <FormattedMessage id="airport.logo.text1" defaultMessage="Drag an image here or" />
                  <button type="button" onClick={() => open()}>
                    <FormattedMessage id="airport.logo.button" defaultMessage="browse" />
                  </button>
                  <FormattedMessage id="airport.logo.text2" defaultMessage="for an image to upload." />
                </p>
              </>
            )}
          </Dropzone>
        )}
        {answer?.length > 0 && (
          <div className={styles.photos}>
            {answer && answer.map(e => (
              <div key={e.name} className={styles.wrapper}>
                <Clickable onClick={() => this.handleRemoveImage(e)}>&times;</Clickable>
                {(e.type || e.content_type).includes('image') ? (
                  <img src={e.preview || e.url} alt={e.file_name || e.name} />
                ) : <p>{e.file_name || e.name}</p>
                }
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}


Attachment.defaultProps = {
  answer: []
};

Attachment.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
  fieldId: PropTypes.string.isRequired,
  answer: PropTypes.string,
  isRequired: PropTypes.bool.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  updateFieldErrors: PropTypes.func.isRequired
};

export default Attachment;
